import React, { createContext, useState, useContext } from 'react';
import { LoadingSpinner } from '@havenengineering/module-shared-library';

interface AppLoading {
  isAppLoading: boolean;
  setIsAppLoading: (value: boolean) => void;
}

const defaultSetIsAppLoading = (value: boolean) => {
  console.warn(`setIsAppLoading called before it was initialized with value ${value}`);
};

const LoadingContext = createContext<AppLoading>({
  isAppLoading: false,
  setIsAppLoading: defaultSetIsAppLoading,
});

export const useAppLoading = () => {
  return useContext(LoadingContext);
};

export const AppLoadingProvider = ({ children }: any) => {
  const [isAppLoading, setIsAppLoading] = useState<boolean>(false);

  return (
    <LoadingContext.Provider value={{ isAppLoading, setIsAppLoading }}>
      {isAppLoading ? <LoadingSpinner loading /> : null}
      <div style={{ display: !isAppLoading ? 'block' : 'none' }}>{children}</div>
    </LoadingContext.Provider>
  );
};
